import type {
  EquipmentPurchasePlanApproveApiData,
  EquipmentPurchasePlanApproveApiResponses,
  EquipmentPurchasePlanAssignBuyerApiData,
  EquipmentPurchasePlanAssignBuyerApiResponses,
  EquipmentPurchasePlanCompleteApiData,
  EquipmentPurchasePlanCompleteApiResponses,
  EquipmentPurchasePlanCreateApiData,
  EquipmentPurchasePlanCreateApiResponses,
  EquipmentPurchasePlanDeleteApiData,
  EquipmentPurchasePlanDeleteApiResponses,
  EquipmentPurchasePlanFromAlertsApiData,
  EquipmentPurchasePlanFromAlertsApiResponses,
  EquipmentPurchasePlanGetApiData,
  EquipmentPurchasePlanGetApiResponses,
  EquipmentPurchasePlanItemPatchApiData,
  EquipmentPurchasePlanItemPatchApiResponses,
  EquipmentPurchasePlanListApiData,
  EquipmentPurchasePlanListApiResponses,
  EquipmentPurchasePlanMarkReceivingApiData,
  EquipmentPurchasePlanMarkReceivingApiResponses,
  EquipmentPurchasePlanPreviewApiData,
  EquipmentPurchasePlanPreviewApiResponses,
  EquipmentPurchasePlanReceiveApiData,
  EquipmentPurchasePlanReceiveApiResponses,
  EquipmentPurchasePlanRejectApiData,
  EquipmentPurchasePlanRejectApiResponses,
  EquipmentPurchasePlanSubmitApiData,
  EquipmentPurchasePlanSubmitApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const equipmentPurchasePlanUrls = {
  getPaginatedEquipmentPurchasePlans: dataEndpoint<
    EquipmentPurchasePlanListApiData,
    EquipmentPurchasePlanListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('inventory/equipment-purchase-plans/', queryParams)
  }),
  getEquipmentPurchasePlan: dataEndpoint<EquipmentPurchasePlanGetApiData, EquipmentPurchasePlanGetApiResponses>({
    getUrl: ({ equipmentPurchasePlanId }) => apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/`)
  }),
  postEquipmentPurchasePlan: responseEndpoint<
    EquipmentPurchasePlanCreateApiData,
    EquipmentPurchasePlanCreateApiResponses
  >({
    getUrl: () => apiUrl('inventory/equipment-purchase-plans/'),
    getBody: (data) => data
  }),
  getEquipmentPurchasePlanPreview: dataEndpoint<
    EquipmentPurchasePlanPreviewApiData,
    EquipmentPurchasePlanPreviewApiResponses
  >({
    getUrl: (queryParams) => apiUrl('inventory/equipment-purchase-plans/preview/', queryParams)
  }),
  postEquipmentPurchasePlanFromStockAlerts: responseEndpoint<
    EquipmentPurchasePlanFromAlertsApiData,
    EquipmentPurchasePlanFromAlertsApiResponses
  >({
    getUrl: () => apiUrl('inventory/equipment-purchase-plans/from-stock-alerts/'),
    getBody: (data) => data
  }),
  postEquipmentPurchasePlanAssignBuyer: responseEndpoint<
    EquipmentPurchasePlanAssignBuyerApiData,
    EquipmentPurchasePlanAssignBuyerApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/assign-buyer/`),
    getBody: ({ equipmentPurchasePlanId: _, ...body }) => body
  }),
  postEquipmentPurchasePlanSubmit: responseEndpoint<
    EquipmentPurchasePlanSubmitApiData,
    EquipmentPurchasePlanSubmitApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/submit/`)
  }),
  postEquipmentPurchasePlanApprove: responseEndpoint<
    EquipmentPurchasePlanApproveApiData,
    EquipmentPurchasePlanApproveApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/approve/`)
  }),
  postEquipmentPurchasePlanReject: responseEndpoint<
    EquipmentPurchasePlanRejectApiData,
    EquipmentPurchasePlanRejectApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/reject/`)
  }),
  patchEquipmentPurchasePlanItem: responseEndpoint<
    EquipmentPurchasePlanItemPatchApiData,
    EquipmentPurchasePlanItemPatchApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId, equipmentPurchasePlanItemId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/items/${equipmentPurchasePlanItemId}/`),
    getBody: ({ equipmentPurchasePlanId: _, equipmentPurchasePlanItemId: __, ...body }) => body
  }),
  postEquipmentPurchasePlanMarkReceiving: responseEndpoint<
    EquipmentPurchasePlanMarkReceivingApiData,
    EquipmentPurchasePlanMarkReceivingApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/mark-receiving/`)
  }),
  postEquipmentPurchasePlanComplete: responseEndpoint<
    EquipmentPurchasePlanCompleteApiData,
    EquipmentPurchasePlanCompleteApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) =>
      apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/complete/`)
  }),
  postEquipmentPurchasePlanReceive: responseEndpoint<
    EquipmentPurchasePlanReceiveApiData,
    EquipmentPurchasePlanReceiveApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId, equipmentPurchasePlanItemId }) =>
      apiUrl(
        `inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/items/${equipmentPurchasePlanItemId}/receive/`
      ),
    getBody: ({ equipmentPurchasePlanId: _, equipmentPurchasePlanItemId: __, ...body }) => body
  }),
  deleteEquipmentPurchasePlan: dataEndpoint<
    EquipmentPurchasePlanDeleteApiData,
    EquipmentPurchasePlanDeleteApiResponses
  >({
    getUrl: ({ equipmentPurchasePlanId }) => apiUrl(`inventory/equipment-purchase-plans/${equipmentPurchasePlanId}/`)
  })
};
